import { EllipsedText, Loading, VirtualizedComponent } from '@gorila-shared-ui/components';
import { ListItem, ListItemLabel } from 'baseui/list';
import { CSSProperties, memo, useRef } from 'react';
import { ListChildComponentProps } from 'react-window';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useHover } from 'usehooks-ts';
import { SMALL_LIST_ITEM_HEIGHT } from '../../../constants/app';
import { useStyles } from '../../../hooks/useStyles';
import { selectedSubAccountIdState, subAccountState } from '../../../storage/subAccounts';

function SubAccountItem({ data, index, style }: Readonly<ListChildComponentProps<VirtualizedComponent['data']>>) {
  const { overrides } = useStyles();
  const [selectedSubAccountId, setSelectedSubAccountId] = useRecoilState(selectedSubAccountIdState);
  const subAccountId = data.items[index];
  const subAccount = useRecoilValue(subAccountState(subAccountId));
  const hoverRef = useRef(null);
  const isHover = useHover(hoverRef);

  const isSelected = selectedSubAccountId === subAccountId;

  const onSelectSubAccount = () => {
    if (selectedSubAccountId === subAccountId) setSelectedSubAccountId(undefined);
    else setSelectedSubAccountId(subAccountId);
  };

  return (
    <span
      style={style as CSSProperties}
      ref={hoverRef}
    >
      {data.isLoaded(index) ? (
        <ListItem
          overrides={overrides.listItemOverrides({
            onClick: onSelectSubAccount,
            isHover,
            isSelected,
            minHeight: SMALL_LIST_ITEM_HEIGHT,
          })}
        >
          <ListItemLabel>
            <EllipsedText inline>{subAccount?.name || '-'}</EllipsedText>
          </ListItemLabel>
        </ListItem>
      ) : (
        <Loading size="compact" />
      )}
    </span>
  );
}

export default memo(SubAccountItem);
